import type { ReactElement } from 'react';

/**
 * 회원 아바타 — 카카오톡 기본 프로필 형태.
 *
 * 실제 프로필 이미지가 아직 없다. 이름 첫 글자를 넣는 방식도 써 봤지만, 소셜에서 이미지를
 * 받아오기 시작하면 **같은 자리에 두 가지 표현**이 섞여 목록이 지저분해진다.
 * 회색 면에 흰 실루엣은 「아직 사진이 없는 사람」이라는 뜻이 분명해서 그대로 두어도 어색하지 않다.
 *
 * 이미지가 생기면 여기서 `<img>` 로 갈아끼우고 호출부는 건드리지 않는다.
 */
export function MemberAvatar({ className = '' }: { className?: string }): ReactElement {
  return (
    <span
      aria-hidden="true"
      className={`grid size-9 shrink-0 place-items-center overflow-hidden rounded-full bg-[#BFC5CB] text-white ${className}`}
    >
      <svg viewBox="0 0 36 36" fill="currentColor" aria-hidden="true" className="size-full">
        <circle cx="18" cy="13.5" r="6" />
        <path d="M18 21.5c-6.2 0-11.2 4-11.2 9V36h22.4v-5.5c0-5-5-9-11.2-9Z" />
      </svg>
    </span>
  );
}
